import React from "react";

export default function About() {
  return <div>This is Astroworker's about page.</div>;
}
